<p-dialog
  [(visible)]="this.visible"
  (onHide)="this.reset()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  styleClass="new-bot-dialog"
  [style]="{'width': '760px', 'max-width': '95vw'}"
>
  <ng-template #header>
    @if (this.currentStep() === 'select' || (this.currentStep() === 'config' && this.availableTemplates().length === 0))
    {
    <span
      class="fw-bold"
      i18n="@@create-new-bot-title"
    > Neuen Bot erstellen</span>
    } @else {
    <div class="d-flex align-items-center gap-2">
      <p-button
        icon="ri ri-arrow-left-line"
        [text]="true"
        [plain]="true"
        size="small"
        [disabled]="this.disabled()"
        (onClick)="this.back()"
      />
      @if (this.selectedTemplate; as template) {
      <span class="fw-bold"><i class="ri-xl me-2 ri-layout-5-line"></i>{{ template.name }}</span>
      } @else {
      <span class="fw-bold"><i class="ri-xl me-2 ri-add-line"></i><span i18n="@@new-bot-blank-template">Leerer
          Bot</span></span>
      }
    </div>
    }
  </ng-template>

  <!-- Step 1: Vorlagen-Übersicht -->
  @if (this.currentStep() === 'select') {
  <p
    class="text-muted mb-3"
    i18n="@@new-bot-select-template-intro"
  >Vorlagen bringen fertige Anweisungen, Skills und Einstellungen mit. Wähle eine Vorlage als Ausgangspunkt oder starte
    mit einem leeren Bot.</p>
  @if (this.showSearch()) {
  <p-iconfield class="d-block mb-3">
    <p-inputicon class="ri ri-search-line" />
    <input
      pInputText
      fluid
      type="search"
      i18n-placeholder="@@new-bot-template-search-placeholder"
      placeholder="Vorlagen durchsuchen"
      i18n-aria-label="@@new-bot-template-search-placeholder"
      aria-label="Vorlagen durchsuchen"
      [ngModel]="this.searchTerm()"
      (ngModelChange)="this.searchTerm.set($event)"
    >
  </p-iconfield>
  }
  <div class="template-grid">
    <button
      type="button"
      class="template-card template-card-blank"
      (click)="this.selectTemplate(null)"
    >
      <span class="template-card-blank-icon"><i class="ri-add-line ri-xl"></i></span>
      <span
        class="template-card-name fw-semibold"
        i18n="@@new-bot-blank-template"
      >Leerer Bot</span>
      <span
        class="template-card-desc text-muted"
        i18n="@@new-bot-blank-template-desc"
      >Starte ohne Vorlage und konfiguriere alles selbst.</span>
    </button>
    @for (card of this.filteredTemplateCards(); track card.template._id) {
    <button
      type="button"
      class="template-card"
      [title]="card.template.name"
      (click)="this.selectTemplate(card.template)"
    >
      <app-bot-icon
        [botConfig]="card.template"
        [navigateOnClick]="false"
      />
      <span class="template-card-name fw-semibold">{{ card.template.name }}</span>
      @if (card.shortDescription) {
      <span class="template-card-desc text-muted">{{ card.shortDescription }}</span>
      }
    </button>
    }
  </div>
  @if (this.filteredTemplateCards().length === 0) {
  <p
    class="text-muted small mt-3 mb-0"
    i18n="@@new-bot-template-search-empty"
  >Keine Vorlage gefunden. Passe deinen Suchbegriff an oder starte mit einem leeren Bot.</p>
  }
  }

  <!-- Step 2: Name -->
  @if (this.currentStep() === 'config') {
  <div class="d-flex flex-column gap-3">
    <div>
      <label
        for="new-bot-name"
        class="form-label fw-semibold"
        i18n="@@name-label"
      >Name:</label>
      <input
        id="new-bot-name"
        class="new-bot-name-input"
        pInputText
        fluid
        type="text"
        [pAutoFocus]="true"
        [(ngModel)]="this.name"
        [disabled]="this.disabled()"
        (keydown.enter)="this.submit()"
      >
    </div>
    @if (this.templateDescription.trim() !== '') {
    <div class="template-notes-preview">
      <markdown [data]="this.templateDescription"></markdown>
    </div>
    }
  </div>
  }

  <!-- Step 3: Template-Variablen -->
  @if (this.currentStep() === 'vars') {
  <div>
    <p class="text-muted mb-1">
      <span
        i18n="@@new-bot-name-preview-label"
        class="me-1"
      >Bot-Name:</span>
      <strong>{{ this.name }}</strong>
    </p>
    @if (this.templateDescription.trim() !== '') {
    <div class="template-notes-preview mb-4">
      <markdown [data]="this.templateDescription"></markdown>
    </div>
    }
    <p-stepper [value]="1">
      @for (tv of this.visibleTemplateVarValues; track tv; let i = $index; let first = $first; let last = $last) {
      <p-step-item [value]="i + 1">
        <p-step>{{ tv.name }}</p-step>
        <p-step-panel>
          <ng-template
            #content
            let-activateCallback="activateCallback"
          >
            <div class="stepper-var-panel p-3">
              @if (tv.description) {
              <small class="d-block text-muted mb-2">{{ tv.description }}</small>
              }
              @if (tv.type === 'string') {
              <textarea
                pInputTextarea
                rows="3"
                class="w-100"
                [(ngModel)]="tv.value"
              ></textarea>
              }
              @if (tv.type === 'number') {
              <input
                pInputText
                type="number"
                class="w-100"
                [(ngModel)]="tv.value"
              >
              }
              @if (tv.type === 'boolean') {
              <p-toggleSwitch [(ngModel)]="tv.value"></p-toggleSwitch>
              }
              @if (!this.isTemplateVarValid(tv)) {
              <small
                class="text-danger d-block mt-1"
                i18n="@@template-var-required"
              >Bitte fülle diese Variable aus.</small>
              }
              <div class="d-flex gap-2 mt-3 ">
                @if (!first) {
                <p-button
                  severity="secondary"
                  i18n-label="@@back"
                  label="Zurück"
                  (onClick)="activateCallback(i)"
                ></p-button>
                }
                @if (!last) {
                <p-button
                  severity="primary"
                  i18n-label="@@next"
                  label="Weiter"
                  [disabled]="!this.isTemplateVarValid(tv)"
                  (onClick)="activateCallback(i + 2)"
                ></p-button>
                }
              </div>
            </div>
          </ng-template>
        </p-step-panel>
      </p-step-item>
      }
    </p-stepper>
  </div>
  }

  <ng-template #footer>
    @if (this.currentStep() === 'vars') {
    <p-button
      type="button"
      severity="secondary"
      [outlined]="true"
      i18n-label="@@back"
      label="Zurück"
      [disabled]="this.disabled()"
      (onClick)="this.back()"
    ></p-button>
    }
    @if (this.currentStep() === 'config') {
    <p-button
      type="button"
      severity="primary"
      [label]="this.submitLabel"
      [disabled]="this.name.trim() === '' || this.disabled()"
      [loading]="this.disabled()"
      (onClick)="this.submit()"
    ></p-button>
    }
    @if (this.currentStep() === 'vars') {
    <p-button
      type="button"
      severity="primary"
      i18n-label="@@create-new-bot"
      label="Neuen Bot erstellen"
      [disabled]="!this.canCreateBot"
      [loading]="this.disabled()"
      (onClick)="this.addBot()"
    ></p-button>
    }
  </ng-template>
</p-dialog>